import React from "react";
import { IconButton, Tooltip, CircularProgress } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

export default function ActionButtons({ row, onEdit, onDelete, deleteLoading }) {
  return (
    <>
      <Tooltip title="Edit">
        <IconButton size="small" color="primary" onClick={() => onEdit(row)}>
          <EditIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Delete">
        <IconButton
          size="small"
          color="secondary"
          onClick={() => onDelete(row)}
          disabled={deleteLoading === row.id}
        >
          {deleteLoading === row.id ? <CircularProgress size={18} /> : <DeleteIcon fontSize="small" />}
        </IconButton>
      </Tooltip>
    </>
  );
}
